module.exports = __webpack_public_path__ + "assets/img/11icon.bf6d2f51.png";